import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-recycle",
  "use": "icon-recycle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-recycle\"><path d=\"M736.1 224V66.2h-448V224H64.2v64h895.9v-64h-224z m-384-93.8h320.1V224H352.1v-93.8zM737.1 896.2H288v-576h-64v640h577.1v-640h-64z\" p-id=\"70606\" fill=\"currentColor\" /><path d=\"M352.1 384.1h64v447.6h-64zM480.1 384.1h64v447.6h-64zM608.1 385.5h64v446.2h-64z\" p-id=\"70607\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol